import styled from '@emotion/styled';
import { isArchivedTracker } from '@racemap/utilities/functions/validation';
import type { FC } from 'react';
import { toast } from 'react-toastify';
import { useTrackersForAction } from '../../../lib/customHooks';
import { useStore } from '../../../store/reducers';

export const ClearErrorMessagesButton: FC = () => {
  const trackersToUse = useTrackersForAction();
  const { clearAllTrackerMessages } = useStore((s) => s.trackers.actions);

  if (trackersToUse == null) return <></>;

  const handleClick = async () => {
    const trackersToUseIds = trackersToUse
      .filter((tracker) => !isArchivedTracker(tracker))
      .map((tracker) => tracker.id);

    clearAllTrackerMessages(trackersToUseIds);

    toast.success('Cleared all error messages!');
  };

  return (
    <Container onClick={() => handleClick()}>
      <div>Clear error messages</div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;
